import Root from './Root';
import { createRoot } from 'react-dom/client';
import React from "react";
import "@fortawesome/fontawesome-free/css/all.min.css";
import './i18next/i18n';
import "react-toastify/dist/ReactToastify.css";

const container = document.getElementById('root');
const root = createRoot(container!); // createRoot(container!) if you use TypeScript
root.render(<Root />);